export default [{
    path: '/organisation/',
    name: 'organisation',
    component: () => import('@/views/assureur/organisation/Organisation.vue'),
},
]